<template>

  <el-dialog :show-close="true" :title="dialogTitle" :visible="dialogVisible" width="30%" @close="bntClick(null)">
    <el-col style="margin-bottom: 15px">
      <span style="white-space: break-spaces;">{{ dialogContent }}</span>
    </el-col>
    <div slot="footer" class="dialog-footer">
      <el-button @click="bntClick(null)">{{ leftBtn }}</el-button>
      <el-button :type="rightBtnType" @click="bntClick(dialogContent)">{{ rightBtn }}</el-button>
    </div>
  </el-dialog>

</template>

<script>

///通用提示弹框
export default {
  name: "TipsDialog",
  //完整接收props参数
  props: {
    dialogVisible: {
      type: Boolean,
      default: false //默认值
      // required:true //是必要的
    },
    dialogTitle: {
      type: String,
      default: ""
    },
    dialogContent: {
      type: String,
      default: ""
    },
    leftBtn: {
      type: String,
      default: "取消"
    },
    rightBtn: {
      type: String,
      default: "确认"
    },
    ///按钮类型
    rightBtnType: {
      type: String,
      default: "primary"
    }
  },
  methods: {
    //value!=null 表示点击确定按钮，其他表示取消
    bntClick(value) {
      this.$emit('tipsDialogClick', this.dialogTitle, value)
    }
  }
}
</script>

<style scoped>

</style>